import { httpGet, httpPost } from "@/utils/axios";
import urls from "@/utils/URLConstant";

export async function fetchRestaurantById(
  restaurantId: string,
  reservationId: string,
) {
  if (!restaurantId) {
    throw new Error("restaurantId is required to fetch restaurant");
  }
  const response = await httpGet(
    urls.PREORDER.restaurant(restaurantId, reservationId),
  );
  return response.data;
}

export async function fetchModificationsByIds(modificationIds: string[]) {
  if (!modificationIds || modificationIds.length === 0) {
    return [];
  }
  const response = await httpPost(urls.PREORDER.getModificationsByIds, {
    modificationIds,
  });
  return response.data || [];
}

const restaurantService = { fetchRestaurantById, fetchModificationsByIds };
export default restaurantService;
